var $trees;

if (typeof TGN == 'undefined') {
	if (typeof YAHOO != 'undefined') {
		$trees = YAHOO.namespace('Ancestry.Trees');
	} else {
		$trees = {};
	}
} else {
	$trees = TGN.namespace('TGN.Ancestry.Trees');
}
$trees.res =
{
	/// <summary>dictionary of resource strings</summary>
	resourceStrings: null,

	/// <summary></summary>
	getString: function(key)
	{
		var value = (null != $trees.res.resourceStrings) ? $trees.res.resourceStrings[key] : null;
		return (value) ? value : '$$' + key;
	},

	/// <summary></summary>
	setString: function(key, value)
	{
		if (!$trees.res.resourceStrings)
			$trees.res.resourceStrings = {};

		$trees.res.resourceStrings[key] = value;
	}
};

$trees.content =
{
	objs: null,

	/// <summary></summary>
	getObject: function (key) {
		return (null != $trees.content.objs) ? $trees.content.objs[key] : null;
	},

	/// <summary></summary>
	setObject: function (key, value) {
		if (!$trees.content.objs)
			$trees.content.objs = {};

		$trees.content.objs[key] = value;
	},

	getPersonKey: function (tid, pid) {
		return 'person_' + pid.toString();
	},

	setPerson: function (tid, pid, value) {
		$trees.content.setObject($trees.content.getPersonKey(tid, pid), value);
	},

	getPerson: function (tid, pid) {
		return $trees.content.getObject($trees.content.getPersonKey(tid, pid));
	},

	addPerson: function (typ, rel, name, gname, sname, birth, birthPlace, death, deathPlace, linkUrl, imgUrl, gender, sid, pid, tid, pageStackArgs) {
		var regExp = /"/g;
		linkUrl = linkUrl.replace(regExp, "'");
		var fm = { 'typ': typ, 'rel': rel, 'name': name, 'gname': gname, 'sname': sname, 'birth': birth, 'birthPlace': birthPlace, 'death': death, 'deathPlace': deathPlace, 'linkUrl': linkUrl, 'imgUrl': imgUrl, 'gender': gender, 'sid': sid, 'pid': pid, 'tid': tid, 'pageStackArgs': pageStackArgs };
		$trees.content.setPerson(tid, pid, fm);
		return fm;
	}
};

$trees.util =
{
	/// <summary></summary>
	gotoTemplate: null,

	/// <summary></summary>
	setGotoTemplate: function (template) {
		$trees.util.gotoTemplate = template;
	},

	/// <summary>Go to person in a way that is page-specific.</summary>
	gotoPerson: function (tid, pid) {
		if ($trees.util.gotoTemplate != null && pid != null) {
			var url = $trees.util.gotoTemplate.indexOf("{p}") !== -1 ? $trees.util.gotoTemplate.replace("{t}", tid).replace("{p}", pid) : unescape($trees.util.gotoTemplate).replace(/{cfpid}/, pid);
			window.location.href = url;
		}
	},

	/// <summary></summary>
	/// <param name="name"></param>
	/// <returns></returns>
	getShortName: function (name) {

		if (name && 40 < name.length) {
			var temp = [];
			temp = name.split(' ');

			name = temp[0].charAt(0) + ' ';
			name += temp[temp.length - 1];
		}
		return name;
	},

	/// <summary>extract year from date blob</summary>
	/// <param name="date">date blob from which to extract year</param>
	/// <returns>empty string if year not found; year string otherwise</returns>
	getYearFromDate: function (date) {
		var year = '';
		if (date && '' != date) {
			var validYear = validDateSimple(date);
			if (0 == validYear[0])
				year = validYear[1];
		}
		return year;
	},

	imposeMaxLength: function (Object, MaxLen) {
		if (Object.value.length > MaxLen) {
			Object.value = Object.value.substring(0, MaxLen);
		}
		return true;
	},

	htmlEncode: function (s) {
		var div = document.createElement('div');
		var text = document.createTextNode(s);
		div.appendChild(text);
		return div.innerHTML;
	},

	htmlDecode: function (s) {
		var div = document.createElement('div');
		div.innerHTML = s.replace(/<\/?[^>]+>/gi, '');
		return div.childNodes[0] ? div.childNodes[0].nodeValue : '';
	},

	// append the given args to the url, making sure that none of them are already parameters in the given url
	// also, remove any of the args from the url that are found in the comma-delimeted list in stripArgs
	//
	appendArgsDistinct: function (url, args, stripArgs) {
		var toStrip = stripArgs.split(",");
		var conjunction = "?";
		var hookPos = url.indexOf("?");
		if (hookPos > 0) {
			// the url has parameters to begin with, so check them all and remove any that would cause duplicates or that are in stripArgs
			var existingUrlArgs = url.substring(hookPos + 1);
			while (existingUrlArgs.length > 0) {
				var nextArgPos = existingUrlArgs.indexOf("&");
				var endArg = existingUrlArgs.indexOf("=");
				if (endArg < 0) endArg = existingUrlArgs.length;
				var checkingArg = existingUrlArgs.substring(0, endArg);
				if (args.indexOf(checkingArg + "=") >= 0 || this.contains(toStrip, checkingArg)) {
					var endArgWithVal = (nextArgPos > 0) ? nextArgPos : existingUrlArgs.length;
					var removeArg = existingUrlArgs.substring(0, endArgWithVal);
					var removePos = url.indexOf(removeArg);
					if (url.length > removePos + removeArg.length) {
						url = url.replace(removeArg + "&", "");
					}
					else {
						var hookOrAmp = url.charAt(removePos - 1);
						url = url.replace(hookOrAmp + removeArg, "");
					}
				}
				existingUrlArgs = (nextArgPos > 0) ? existingUrlArgs.substring(nextArgPos + 1) : "";
			}
			if (url.length > hookPos) conjunction = "&";
		}
		// place the additional args on the url
		url = url + conjunction + args;
		return url;
	},

	contains: function (arr, obj) {
		for (var i = 0; i < arr.length; i++) {
			if (arr[i] === obj) return true;
		}
		return false;
	},

	trim: function (str) {
		return str.replace(/^\s*(\S*(\s+\S+)*)\s*$/, "$1");
	},

	setPageTrackingName: function (page, func) {
		if (typeof s_gi === 'undefined' || typeof s_account === 'undefined') {
			return;
		}
		s = s_gi(s_account);
		if (s.pageName.length == 0 || s.pageName.indexOf(":") == -1) {
			s.pageName = "Ancestry ?? : Trees :";
		}
		// find the first ":"
		var index = s.pageName.indexOf(":");
		// find the second ":"
		index = s.pageName.indexOf(":", index + 1);
		if (index != -1) {
			// build the name
			s.pageName = s.pageName.substring(0, index + 1) + " " + page + " : " + func;
		}
		else {
			s.pageName = "Ancestry ?? : Trees : " + page + " : " + func;
		}
		s_pageName = s.pageName;
		s.t();
	},

	getParameterByName: function (name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
			results = regex.exec(location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	},

	appendPageArgs: function (url, pageArgs) {
		if (url.indexOf('?') == -1)
			return url + '?' + pageArgs;

		return url + '&' + pageArgs;
	},

	buildUrlWithHistory: function (pageName, urlArgs, staticUrl, pageStackArgs) {
		var deferred = $.Deferred();

		//PUB V2
		if (typeof (ancestry) != 'undefined' && ancestry.pub) {
			ancestry.pub.buildUrl()
				.toGoTo(pageName, urlArgs)
				.toComeBackToCurrent()
				.build(function (err, url) {
					if (err && window.console != null)
						console.warn(err);
					deferred.resolve(url);
				});
		}
		// PUB V1
		else {
			deferred.resolve($trees.util.appendPageArgs(staticUrl, pageStackArgs));
		}

		return deferred;
	},

	/**
	 * Invokes the utag.link function
	 * @param {any} linkName
	 * @param {any} action
	 */
	link: function (linkName, action) {
		if (window.utag && typeof window.utag.link === "function") {
			window.utag.link({
				link_name: linkName,
				action: action
			});
		}
	},

    getAjaxUrlPrefix: function() {
        var onWww = window.location.hostname.substring(0, 12) === 'www.ancestry';
        return onWww ? '/family-tree' : '';
    },

	decodeHTML: function (obj) {
		var div = document.createElement('div');
		if (typeof(obj) == 'object') {
			for(var prop in obj) {
				var value = obj[prop];
				if (value) {
					div.innerHTML = value;
					obj[prop] = div.innerText || div.textContent || value;
				}

				div.innerHTML = "";
			}
		} else if (typeof(obj) == 'string') {
			div.innerHTML = obj;
			obj = div.innerText || div.textContent || obj;
		}

		return obj;
	}
};



function expandCollapse() {
	for (var i = 0; i < expandCollapse.arguments.length; i++) {
		var element = $("#" + expandCollapse.arguments[i]);
		if (element)
			element.toggle();
	}
}
function expandElement() {
	for (var i = 0; i < expandElement.arguments.length; i++) {
		var element = $("#" + expandElement.arguments[i]);
		if (element)
			element.show();
	}
}
function collapseElement() {
	for (var i = 0; i < collapseElement.arguments.length; i++) {
		var element = $("#" + collapseElement.arguments[i]);
		if (element)
			element.hide();
	}
}
function addClass(elId, className) {
	var elIdItem = $('#' + elId);
	if(elIdItem)
		elIdItem.addClass(className);
}
function removeClass(elId, className) {
	var elIdItem = $('#' + elId);
	if (elIdItem)
		elIdItem.removeClass(className);
} 
var ToClear, ToShow, currentDiv, oldDiv;
function showHover() {
	//close other card menues
	var treeMenu = null;
	var printPubMenu = null;
	var moreOptMenu = null;
	if (showHover.arguments[0] == 'moreOptMenu') {
		treeMenu = $("#treeMenu");
		if(treeMenu)
			treeMenu.hide();
		printPubMenu = $("#printPubMenu");
		if (printPubMenu)
			printPubMenu.hide();
	}
	else if (showHover.arguments[0] == 'treeMenu') {
		moreOptMenu = $("#moreOptMenu");
		if (moreOptMenu)
			moreOptMenu.hide();
		printPubMenu = $("#printPubMenu");
		if (printPubMenu)
			printPubMenu.hide();
	}
	else if (showHover.arguments[0] == 'printPubMenu') {
		var treeMenu = $("#treeMenu");
		if (treeMenu)
			treeMenu.hide();
		moreOptMenu = $("#moreOptMenu");
		if (moreOptMenu)
			moreOptMenu.hide();
	}

	if (oldDiv != 'undefined' && oldDiv)
		closeHover(oldDiv);
	currentDiv = showHover.arguments[0];
	oldDiv = currentDiv;
	var element = $('#' + currentDiv);
	ToShow = setTimeout(function() {
		if (element)
			element.show();
	}, 500);
}
function closeHover() {
	var element = $('#' + closeHover.arguments[0]);
	
	if (element)
		element.hide();

	hoverTimeoutClear();
}
function onHoverInit() {
	hoverTimeoutClear();
}
function hoverTimeout() {
	hoverTimeoutClear();
	currentDiv = hoverTimeout.arguments[0];
	if (currentDiv != 'undefined' && currentDiv != null)
		ToClear = setTimeout("closeHover('" + currentDiv + "')", 250, "JAVASCRIPT");
}
function hoverTimeoutClear() {
	if (ToShow != -1) { window.clearTimeout(ToShow); ToShow = 0; }
	if (ToClear != -1) { window.clearTimeout(ToClear); ToClear = 0; }
}

function swapClass(row, oldClass) {
	$('#' + row).css('class', oldClass);
	if (oldClass == 'tblrowOver') {
		$('#' + row + 'control').css('class', 'resultsInfo');
	} else {
		$('#' + row + 'control').css('class', 'resultsHidden');
	}
}
function guidelines() {
	window.open(v_communityPartner + '/guidelines.aspx', '', 'toolbar=no,scrollbars=1,resizable=1,menubar=no,location=no,height=425,width=575');
}
function onclickBrowse(windowname, wwidth) {
	onclickOpenBrowseWindow(windowname, wwidth);
}
function onclickOpenBrowseWindow(windowname, wwidth) {
	if (!windowname) {
		windowname = '_blank';
	}
	if (!wwidth) {
		wwidth = '800';
	}
	var wparams = 'toolbar=no,resizable=yes,scrollbars=yes,menubar=no,status=no,location=no,height=550,width=';
	if (wwidth != "") {
		wparams = wparams + wwidth;
	}
	else {
		wparams = wparams + '800';
	}
	if (v_browseURL != '') {
		window.open(v_browseURL, windowname, wparams, true);
	}
}